// SLA targets are stored in hours and may be fractional (0.5 = 30 min).
// Formats them compactly for chips and lists: 0.5 → "30 min", 8 → "8h", 1.5 → "1h 30 min".
export const formatSlaHours = hours => {
  const totalMinutes = Math.round(Number(hours) * 60);
  if (!Number.isFinite(totalMinutes) || totalMinutes <= 0) return '';

  const wholeHours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  if (!wholeHours) return `${minutes} min`;
  if (!minutes) return `${wholeHours}h`;
  return `${wholeHours}h ${minutes} min`;
};
